import pop from  "../assets/pop.mp3"

export const playNewMessageSound = () => {
    new Audio(pop).play();
};